import TabsMiddleContent from './TabsMiddleContent';

export default TabsMiddleContent;
